// Imports
var ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___ = require("../../../node_modules/html-loader/dist/runtime/getUrl.js");
var ___HTML_LOADER_IMPORT_0___ = require("../../assets/images/icons/success.svg");
var ___HTML_LOADER_IMPORT_1___ = require("../../assets/images/icons/closeBlue.svg");
// Module
var ___HTML_LOADER_REPLACEMENT_0___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_0___);
var ___HTML_LOADER_REPLACEMENT_1___ = ___HTML_LOADER_GET_SOURCE_FROM_IMPORT___(___HTML_LOADER_IMPORT_1___);
var code = "<div id=\"{{id}}\" class=\"{{class}}\"> <img class=\"icon\" alt=\"icon\" src=\"" + ___HTML_LOADER_REPLACEMENT_0___ + "\"/> <div class=\"message\"></div> <div class=\"close\"> <img alt=\"close\" src=\"" + ___HTML_LOADER_REPLACEMENT_1___ + "\"/> </div> </div>";
// Exports
module.exports = code;